import { useState, useEffect, useRef } from 'react';
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import moment from 'moment';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { Dialog } from 'primereact/dialog';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import ExcelJS from 'exceljs';
import { Dropdown } from 'primereact/dropdown';

const AddEditAcademicCalenderSpecific = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const importFileUploadRef = useRef(null);
    const [formData, setFormData] = useState({
        academicYearId: "",
        academicYearIdErr: false,
        academicYearIdErrText: '',
        classesApplicableErr: false,
        classesApplicableErrText: '',
        classesApplicable: [],
        importURL: "",
        importFile: null,
    });
    const [overlapKeys, setOverlapKeys] = useState([]);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [classList, setClassList] = useState([]);
    const [academicYearList, setAcademicYearList] = useState([]);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isDeleteExcelConfirmation, setIsDeleteExcelConfirmation] = useState(false);
    const [isDeleteHolidayConfirmation, setIsDeleteHolidayConfirmation] = useState(false);
    const academicYearNameRef = useRef(null);
    const [deletedIndex, setDeletedIndex] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            academicYearNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id, 'sectionWise');
        getFinancialYearClassList(loginData?._id);
        if (props?.configId) {
            GetAcademicCalanderDetail(props?.configId, loginData?._id);
        } else {
            const newRow = {
                srNo: 1,
                StartDate: '',
                EndDate: '',
                Name: '',
                Remark: '',
                isEdit: true,
                isAutoGenerated: false
            };

            setExcelData(prev => {
                const updated = [newRow, ...prev];
                return updated.map((row, idx) => ({ ...row, srNo: idx + 1 }));
            });
        }
    }, []);

    useEffect(() => {
        if (!formData.academicYearId || !academicYearList.length) {
            setAcademicStartDate(null);
            setAcademicEndDate(null);
            return;
        }
        
        const selectedAcademicYearData = academicYearList.find(
            y => y?.value === formData?.academicYearId?._id
        );
        
        if (CommonConfig.isEmpty(selectedAcademicYearData)) {
            setAcademicStartDate(null);
            setAcademicEndDate(null);
            return;
        }

        const start = new Date(selectedAcademicYearData?.StartDate);
        const end = new Date(selectedAcademicYearData?.EndDate);

        setAcademicStartDate(start);
        setAcademicEndDate(end);

    }, [academicYearList, formData.academicYearId]);

    const getFinancialYearClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getAcademicCalanderTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (res?.data) {
                        const years = res?.data?.flatMap((y) =>
                            y?.CalendarValue?.map((x) => ({
                                ...x,
                                label: `${y?.TitleName}(${moment(x?.StartDate).format("MM/YYYY")}-${moment(x?.EndDate).format("MM/YYYY")})`,
                                _id: x?._id,
                            }))).filter(Boolean) || [];

                        setAcademicYearList(years);
                    } else {
                        setAcademicYearList([]);
                    }
                } else {
                    console.log("Error in else get Financial Year: ", res);
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (error) {
            console.log("Error get Financial Year: ", error);
            catchResponse(error);
        }
    }

    const GetAcademicCalanderDetail = async (id, userId) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.getAcademicSpecificCalanderById, data).then(async response => {
                let res = response;
                if (res.success) {
                    const detailData = res?.data;
                    setFormData((prev) => ({
                        ...prev,
                        academicYearId: detailData?.AcademicYearId,
                        classesApplicable: detailData?.ApplicableClass?.split(',') || [],
                    }));

                    const validHolidayData = (detailData?.HolidayData || []).filter(
                        item => item?.StartDate?.toString()?.trim()
                    );

                    if (validHolidayData.length > 0) {
                        const excelData = validHolidayData?.map((z, idx) => ({
                            ...z,
                            srNo: idx + 1,
                            StartDate: z?.StartDate ? normalizeDate(z?.StartDate) : '',
                            EndDate: z?.EndDate ? normalizeDate(z?.EndDate) : ''
                        }));
                        setExcelData(excelData);
                    } else {
                        const newRow = {
                            srNo: 1,
                            StartDate: '',
                            EndDate: '',
                            Name: '',
                            Remark: '',
                            isEdit: true,
                            isAutoGenerated: false
                        };

                        setExcelData(prev => {
                            const updated = [newRow, ...prev];
                            return updated.map((row, idx) => ({ ...row, srNo: idx + 1 }));
                        });
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleCloseExcelConfirmation = () => {
        setIsDeleteExcelConfirmation(false);
    };

    const handleCloseHolidayConfirmation = () => {
        setIsDeleteHolidayConfirmation(false);
        setDeletedIndex(null);
    };

    const GetClassList = async (id, type) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let classData = res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    }));
                    setClassList(classData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const normalizeDateOnly = (dateStr) => {
        if (!dateStr) return null;

        if (dateStr instanceof Date && !isNaN(dateStr)) {
            return new Date(
                dateStr.getFullYear(),
                dateStr.getMonth(),
                dateStr.getDate()
            );
        }

        if (typeof dateStr === 'string') {
            const val = dateStr?.trim();

            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                const [d, m, y] = val.split('/').map(Number);
                return new Date(y, m - 1, d);
            }

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-').map(Number);
                return new Date(y, m - 1, d);
            }
        }

        return null;
    };

    const checkOverlappingHolidays = (records) => {
        const ranges = records
            .filter(r => r?.StartDate)
            .map(r => ({
                start: normalizeDateOnly(r.StartDate),
                end: normalizeDateOnly(r.EndDate || r.StartDate)
            }));

        for (let i = 0; i < ranges.length; i++) {
            for (let j = i + 1; j < ranges.length; j++) {
                const a = ranges[i];
                const b = ranges[j];

                if (a.start <= b.end && a.end >= b.start) {
                    return true;
                }
            }
        }
        return false;
    };

    const getRowKey = (row) => `${row.StartDate}_${row.EndDate}_${row.Name}`;

    const getOverlappingKeys = (records) => {
        const ranges = records.map((r) => ({
            key: getRowKey(r),
            start: normalizeDateOnly(r.StartDate),
            end: normalizeDateOnly(r.EndDate || r.StartDate),
        })).filter(r => r.start && r.end);

        const overlaps = new Set();

        for (let i = 0; i < ranges.length; i++) {
            for (let j = i + 1; j < ranges.length; j++) {
                const a = ranges[i];
                const b = ranges[j];

                if (a.start <= b.end && a.end >= b.start) {
                    overlaps.add(a.key);
                    overlaps.add(b.key);
                }
            }
        }

        return Array.from(overlaps);
    };

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(formData?.academicYearId)) {
            formIsValid = false;
            setFormData((prev) => ({ ...prev, academicYearIdErr: true, academicYearIdErrText: 'Academic Year is required' }));
        } else {
            setFormData((prev) => ({ ...prev, academicYearIdErr: false, academicYearIdErrText: '' }));
        }

        if (formData?.classesApplicable?.length === 0) {
            formIsValid = false;
            setFormData((prev) => ({ ...prev, classesApplicableErr: true, classesApplicableErrText: 'Select atleast one class' }));
        } else {
            setFormData((prev) => ({ ...prev, classesApplicableErr: false, classesApplicableErrText: '' }));
        }

        const validHolidayData = (excelData || []).filter(
            item => item?.StartDate?.toString()?.trim()
        );

        const invalidExcelRecords = validHolidayData.filter(rec => {
            if (!rec.StartDate) return true;
            if (rec.EndDate) {
                const start = new Date(rec.StartDate);
                const end = new Date(rec.EndDate);
                if (start > end) return true;
            }
            return false;
        });

        if (invalidExcelRecords.length > 0) {
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday records have invalid dates. Please check and fix them.'
            }));
        }

        const uniqueRecords = removeDuplicates(excelData);
        if (excelData.length !== uniqueRecords.length) {
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday records are duplicats. Please check and fix them.'
            }));
        }

        const hasOverlap = checkOverlappingHolidays(validHolidayData);

        if (hasOverlap) {
            setOverlapKeys(getOverlappingKeys(validHolidayData));
            formIsValid = false;
            setFormData((prev) => ({
                ...prev,
                holidayErr: true,
                holidayErrText: 'Some holiday date ranges overlap. Please ensure no dates fall within another holiday range.'
            }));
        } else {
            setOverlapKeys([]);
        }

        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
    }

    const handleInputChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
        if (key == 'academicYearId') {
            const selectedAcademicYearData = academicYearList.find(
                y => y?._id === value?._id
            );

            if (CommonConfig.isEmpty(selectedAcademicYearData)) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const start = new Date(selectedAcademicYearData?.StartDate);
            const end = new Date(selectedAcademicYearData?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    };

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                const validHolidayData = (excelData || []).filter(
                    item => item?.StartDate?.toString()?.trim()
                );

                const dataForm = {
                    id: props?.masterData?._id ?? '',
                    AcademicYearId: formData?.academicYearId,
                    ApplicableClass: formData?.classesApplicable?.length > 1 ? formData?.classesApplicable?.join(',') : formData?.classesApplicable[0],
                    CreatedBy: securityUserID,
                    HolidayData: validHolidayData.length > 0 ? JSON.stringify(validHolidayData) : []
                };
                Loader.show();
                await api
                    .post(APIConstant.path.AddUpdateAcademicSpecificCalander, dataForm)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else if (!res.success && res.type === "HOLIDAY_OVERLAP") {
                            setOverlapKeys(res?.conflictRows.map(x => `${x?.StartDate}_${x?.EndDate}_${x?.Name}`));
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        } else {
            Toast.error({ message: "Please fill all required fields correctly" });
        }
    };

    const parseDMY = (str) => {
        const [d, m, y] = str.split('/').map(Number);
        return new Date(y, m - 1, d);
    };

    const removeDuplicates = (records) => {
        const map = new Map();

        records.forEach(rec => {
            const key = `${rec?.StartDate}_${rec?.EndDate}_${rec?.HolidayName}`;
            if (!map.has(key)) {
                map.set(key, rec);
            }
        });

        return Array.from(map.values());
    };

    const handleFileUpload = async (e) => {
        if (!formData?.academicYearId) {
            Toast.error({ message: 'Please select academic year first!' });
            importFileUploadRef.current?.clear();
            return;
        }

        // Derive dates directly from academicYearList instead of relying on state
        const selectedYear = academicYearList.find(y => y?._id === formData?.academicYearId?._id || y?._id === formData?.academicYearId);
        const startDate = selectedYear?.StartDate ? new Date(selectedYear.StartDate) : academicStartDate;
        const endDate = selectedYear?.EndDate ? new Date(selectedYear.EndDate) : academicEndDate;

        if (!startDate || !endDate) {
            Toast.error({ message: 'Please select a academic year first!' });
            importFileUploadRef.current?.clear();
            return;
        }

        const file = e.files?.[0];
        if (!file) return;

        const fileExt = file?.name?.toLowerCase()?.slice(file?.name?.lastIndexOf('.'));
        const validExts = ['.xlsx', '.xls', '.csv'];

        if (!validExts.includes(fileExt)) {
            Toast.error({ message: 'Please upload only .xlsx, .xls or .csv files.' });
            importFileUploadRef.current?.clear();
            return;
        }

        setExcelFileName(file.name);
        setFormData(prev => ({ ...prev, importFile: file }));

        try {
            let rows = [];

            if (fileExt === '.csv') {
                const csvText = await file.text();
                rows = parseCSV(csvText);
            } else {
                const arrayBuffer = await file.arrayBuffer();
                const workbook = new ExcelJS.Workbook();

                await workbook.xlsx.load(arrayBuffer);

                const worksheet = workbook.worksheets[0];
                if (!worksheet) {
                    throw new Error('No worksheet found in the file.');
                }

                let dataFound = false;

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber === 1) return;

                    if (row.values && row.values.length > 1) {
                        dataFound = true;
                        const values = row.values;

                        rows.push({
                            srNo: values[1] ?? (rows.length + 1),
                            StartDate: normalizeDate(values[2]),
                            EndDate: normalizeDate(values[3]),
                            Name: values[4]?.toString()?.trim() || '',
                            Remark: values[5]?.toString()?.trim() || '',
                            isEdit: false,
                            isAutoGenerated: false,
                            rowNumber: rowNumber // Track row number for error messages
                        });
                    }
                });
                if (rows.length === 0 && !dataFound) {
                    Toast.error({ message: 'No data rows found in the file (check if headers match expected columns).' });
                    clearFileInput();
                    return;
                }
            }
            if (rows.length === 0) {
                Toast.error({ message: 'No data found in the file.' });
                clearFileInput();
                return;
            }
            // Validate mandatory fields
            const missingFieldsRows = [];
            rows.forEach((row, index) => {
                const rowNum = row.rowNumber || index + 2; // +2 because index starts at 0 and row 1 is header
                const missingFields = [];

                if (!row.StartDate || row.StartDate === 'Invalid Date') {
                    missingFields.push('Start Date');
                }
                if (!row.EndDate || row.EndDate === 'Invalid Date') {
                    missingFields.push('End Date');
                }
                if (!row.Name || row?.Name?.trim() === '') {
                    missingFields.push('Name');
                }

                if (missingFields.length > 0) {
                    missingFieldsRows.push({ rowNum, fields: missingFields });
                }
            });

            if (missingFieldsRows.length > 0) {
                const errorMessages = missingFieldsRows.slice(0, 5).map(item =>
                    `Row ${item.rowNum}: Missing ${item.fields.join(', ')}`
                ).join('; ');

                const additionalCount = missingFieldsRows.length > 5 ? ` and ${missingFieldsRows.length - 5} more` : '';

                Toast.error({
                    message: `Mandatory fields missing: ${errorMessages}${additionalCount}. Please ensure Start Date, End Date, and Name are provided for all rows.`
                });
                clearFileInput();
                return;
            }

            const startLimit = parseToDate(startDate);
            const endLimit = endDate ? parseToDate(endDate) : startLimit;

            if (isNaN(startLimit) || isNaN(endLimit)) {
                Toast.error({ message: 'Invalid selected date range. Please select a valid range.' });
                clearFileInput();
                return;
            }

            const validatedRows = rows.filter(row => {
                const rowStart = parseToDate(row.StartDate);
                const rowEnd = row.EndDate ? parseToDate(row.EndDate) : rowStart;

                if (isNaN(rowStart) || isNaN(rowEnd)) return false;
                if (row.EndDate && rowStart > rowEnd) return false;

                const withinStart = rowStart >= startLimit && rowStart <= endLimit;
                const withinEnd = rowEnd >= startLimit && rowEnd <= endLimit;

                return withinStart && withinEnd;
            });

            if (validatedRows.length === 0) {
                Toast.error({ message: 'No valid records found within the selected date range or dates are invalid.' });
                clearFileInput();
                return;
            }

            if (validatedRows.length < rows.length) {
                Toast.error({ message: `${rows.length - validatedRows.length} record(s) skipped due to invalid dates or being outside date range.` });
                setExcelFileName("");
                setFormData((prev) => ({ ...prev, importFile: null }));
                if (importFileUploadRef.current) {
                    importFileUploadRef.current.clear();
                }
            }

            const cleanedRows = validatedRows.map(row => {
                const { rowNumber, ...cleanRow } = row;
                return cleanRow;
            });

            setExcelData(prevData => {
                const existingManual = prevData.filter(rec => !rec.isAutoGenerated);
                const autoGenerated = prevData.filter(rec => rec.isAutoGenerated);
                const combined = [...existingManual, ...cleanedRows];
                const filteredCombined = removeDuplicateHolidays(combined, autoGenerated);
                const final = [...filteredCombined, ...autoGenerated];
                const uniqueRecords = removeDuplicates(final);

                return uniqueRecords
                    .sort((a, b) => parseDMY(a.StartDate) - parseDMY(b.StartDate))
                    .map((rec, idx) => ({ ...rec, srNo: idx + 1 }));
            });

        } catch (error) {
            console.error('Excel parsing failed:', error);
            let msg = 'Failed to read the file. Please try a different file.';
            if (error.message.includes('zip') || error.message.includes('central directory')) {
                msg = 'Invalid or corrupted Excel (.xlsx/.xls) file. Try re-saving it in Excel.';
            } else if (error.message.includes('F_OK') || error.message.includes('fs.constants')) {
                msg = 'File system error. Please ensure you are using the browser version of ExcelJS.';
            } else if (fileExt === '.csv' && error.message.includes('CSV')) {
                msg = 'Invalid CSV format. Check for proper delimiters and encoding.';
            }
            Toast.error({ message: msg });
            clearFileInput();
        }
    };

    const removeDuplicateHolidays = (existingRecords, newRecords) => {
        const filtered = existingRecords.filter(existing => {
            const existingStart = new Date(existing.StartDate);
            const existingEnd = new Date(existing.EndDate || existing.StartDate);

            return !newRecords.some(newRec => {
                const newStart = new Date(newRec.StartDate);
                const newEnd = new Date(newRec.EndDate || newRec.StartDate);

                return (
                    (existingStart >= newStart && existingStart <= newEnd) ||
                    (existingEnd >= newStart && existingEnd <= newEnd) ||
                    (newStart >= existingStart && newStart <= existingEnd)
                );
            });
        });

        return filtered;
    };

    const parseToDate = (value) => {
        if (!value) return new Date('Invalid');

        if (value instanceof Date) return value;

        if (typeof value === 'number') {
            const excelEpoch = new Date(1899, 11, 30);
            return new Date(excelEpoch.getTime() + value * 86400000);
        }

        if (typeof value === 'string') {
            const val = value?.trim();

            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                return parseDDMMYYYY(val);
            }

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-');
                return new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
            }

            return new Date(val);
        }
        try {
            return new Date(value);
        } catch {
            return new Date('Invalid');
        }
    };

    const parseDDMMYYYY = (str) => {
        if (!str || typeof str !== 'string') return new Date('Invalid');
        const [d, m, y] = str.split('/');
        return new Date(`${y}-${m}-${d}`);
    };

    const parseCSV = (csvText) => {
        const lines = csvText.split('\n').filter(line => line?.trim());
        const rows = [];

        for (let i = 1; i < lines.length; i++) {
            const values = lines[i]?.split(',')?.map(v => v?.trim()?.replace(/^["']|["']$/g, ''));

            if (values.length > 0 && values[0]) {
                rows.push({
                    srNo: values[0] || (rows.length + 1),
                    StartDate: normalizeDate(values[1]),
                    EndDate: normalizeDate(values[2]),
                    Name: values[3]?.trim() || '',
                    Remark: values[4]?.trim() || '',
                    isEdit: false,
                    isAutoGenerated: false
                });
            }
        }

        return rows;
    };

    const normalizeDate = (value) => {
        if (!value) return '';

        const formatToDDMMYYYY = (date) => {
            if (!(date instanceof Date) || isNaN(date)) return 'Invalid Date';
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };

        // Parse DD/MM/YYYY or DD-MM-YYYY manually (IMPORTANT FIX)
        const parseDMY = (d, m, y) => {
            const day = Number(d);
            const month = Number(m);
            const year = Number(y);
            const date = new Date(year, month - 1, day); // FORCE D-M-Y
            return date;
        };

        if (value instanceof Date) {
            return formatToDDMMYYYY(value);
        }

        if (typeof value === 'string') {
            const val = value?.trim();

            // DD/MM/YYYY
            if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val)) {
                const [d, m, y] = val.split('/');
                return formatToDDMMYYYY(parseDMY(d, m, y));
            }

            // DD-MM-YYYY
            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(val)) {
                const [d, m, y] = val.split('-');
                return formatToDDMMYYYY(parseDMY(d, m, y));
            }

            // Last fallback → attempt natural parsing
            const date = new Date(val);
            if (!isNaN(date.getTime())) {
                return formatToDDMMYYYY(date);
            }

            return 'Invalid Date';
        }

        if (typeof value === 'number') {
            const excelEpoch = new Date(1899, 11, 30);
            const date = new Date(excelEpoch.getTime() + value * 86400000);
            return formatToDDMMYYYY(date);
        }

        return value?.result?.toString()?.trim() || value?.toString()?.trim() || '';
    };

    const clearFileInput = () => {
        importFileUploadRef.current?.clear();
        setExcelFileName('');
        setFormData(prev => ({ ...prev, importFile: null }));
    };

    const downloadSampleCSV = () => {
        const sampleData = [
            ['Sr. no.', 'Start Date', 'End Date', 'Name', 'Remark'],
            ['1', '01/01/2024', '31/01/2024', 'Winter Break', 'School Holiday'],
            ['2', '15/03/2024', '20/03/2024', 'Spring Break', 'Mid-term Holiday'],
            ['3', '01/06/2024', '15/06/2024', 'Summer Vacation', 'Annual Holiday'],
        ];

        const csvContent = sampleData.map(row => row.join(',')).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', 'Sample_Academic_Calendar.csv');
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Toast.success({ message: 'Sample CSV file downloaded successfully!' });
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setFormData((prev) => ({ ...prev, previewImportFile: '', importFile: '' }));
                    if (importFileUploadRef.current) {
                        importFileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const renderExcelDeleteFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseExcelConfirmation}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleCloseExcelConfirmation();
                    setExcelFileName("");
                    setFormData((prev) => ({ ...prev, importFile: null }));
                    if (importFileUploadRef.current) {
                        importFileUploadRef.current.clear();
                    }
                    Toast.success({ message: 'Excel file removed successfully' });
                }}
            />
        </div>
    );

    const renderHolidayDeleteFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseHolidayConfirmation}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleCloseHolidayConfirmation();
                    const updatedData = excelData
                        .filter((_, i) => i !== deletedIndex)
                        .map((row, idx) => ({ ...row, srNo: idx + 1 }));
                    setExcelData(updatedData);
                    Toast.success({ message: 'Row deleted successfully' });
                }}
            />
        </div>
    );

    const handleClassChange = (value) => {
        setFormData((prev) => {
            return {
                ...prev,
                classesApplicable: value
            };
        });
    };

    const handleExcelFieldChange = (rowIndex, field, value) => {
        setExcelData(prev => {
            const updated = [...prev];
            updated[rowIndex] = {
                ...updated[rowIndex],
                [field]: value
            };
            return updated;
        });
    };

    const addNewExcelRow = () => {

        const newRow = {
            srNo: 1,
            StartDate: '',
            EndDate: '',
            Name: '',
            Remark: '',
            isEdit: true,
            isAutoGenerated: false
        };

        setExcelData(prev => {
            const updated = [newRow, ...prev];
            return updated.map((row, idx) => ({ ...row, srNo: idx + 1 }));
        });

        Toast.success({ message: 'New row added' });
    };

    const excelSrNoBodyTemplate = (rowData) => {
        return <span>{rowData.srNo}</span>;
    };

    const parseDDMMYYYYToDate = (str) => {
        if (!str || typeof str !== 'string') return null;
        const parts = str.split('/');
        if (parts.length !== 3) return null;

        const [dStr, mStr, yStr] = parts;
        const d = Number(dStr);
        const m = Number(mStr);
        const y = Number(yStr);

        if (!Number.isInteger(d) || !Number.isInteger(m) || !Number.isInteger(y)) return null;
        if (y < 1000 || m < 1 || m > 12 || d < 1 || d > 31) return null;

        // Construct in ISO order to avoid locale ambiguity
        const date = new Date(`${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
        return isNaN(date) ? null : date;
    };

    const formatToDDMMYYYY = (date) => {
        if (!(date instanceof Date) || isNaN(date)) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const excelStartDateBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            const dateValue = parseDDMMYYYYToDate(rowData?.StartDate);
            return (
                <Calendar
                    value={dateValue}
                    minDate={academicStartDate}
                    maxDate={academicEndDate}
                    onChange={(e) => {
                        const selectedDate = e.value;
                        if (selectedDate) {
                            const formatted = selectedDate ? formatToDDMMYYYY(selectedDate) : '';
                            handleExcelFieldChange(rowIndex, 'StartDate', formatted);
                        } else {
                            handleExcelFieldChange(rowIndex, 'StartDate', '');
                        }
                    }}
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/yyyy"
                    className="p-w-100"
                    showButtonBar
                    readOnlyInput
                />
            );
        }
        return <span>{rowData?.StartDate}</span>;
    };

    const excelEndDateBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            const dateValue = parseDDMMYYYYToDate(rowData?.EndDate);
            const rowStartDate = parseDDMMYYYYToDate(rowData?.StartDate);
            return (
                <Calendar
                    value={dateValue}
                    minDate={rowStartDate || academicStartDate}
                    maxDate={academicEndDate}
                    onChange={(e) => {
                        const selectedDate = e.value;
                        if (selectedDate) {
                            const formatted = selectedDate ? formatToDDMMYYYY(selectedDate) : '';
                            handleExcelFieldChange(rowIndex, 'EndDate', formatted);
                        } else {
                            handleExcelFieldChange(rowIndex, 'EndDate', '');
                        }
                    }}
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/yyyy"
                    className="p-w-100"
                    showButtonBar
                    readOnlyInput
                />
            );
        }
        return <span>{rowData?.EndDate}</span>;
    };

    const excelNameBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            return (
                <InputText
                    value={rowData?.Name}
                    onChange={(e) => handleExcelFieldChange(rowIndex, 'Name', e.target.value)}
                    placeholder="Enter name"
                    className="p-w-100"
                    style={{ fontSize: '14px' }}
                />
            );
        }
        return <span>{rowData?.Name}</span>;
    };

    const excelRemarkBodyTemplate = (rowData, { rowIndex }) => {
        if (rowData?.isEdit) {
            return (
                <InputText
                    value={rowData?.Remark}
                    onChange={(e) => handleExcelFieldChange(rowIndex, 'Remark', e.target.value)}
                    placeholder="Enter remark"
                    className="p-w-100"
                    style={{ fontSize: '14px' }}
                />
            );
        }
        return <span>{rowData?.Remark}</span>;
    };

    const excelActionsBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="p-d-flex p-jc-start">
                {rowData?.isEdit ? (
                    <Button
                        icon="pi pi-check"
                        className="e-sction-btn p-m-0 p-m-2"
                        onClick={() => {
                            if (!rowData?.StartDate) {
                                Toast.error({ message: 'Please enter Start Date' });
                                return;
                            }

                            if (!rowData?.EndDate) {
                                Toast.error({ message: 'Please enter End Date' });
                                return;
                            }

                            if (!rowData?.Name?.trim()) {
                                Toast.error({ message: 'Please enter Holiday Name' });
                                return;
                            }
                            setExcelData(prev => {
                                const updated = [...prev];
                                updated[rowIndex] = {
                                    ...updated[rowIndex],
                                    isEdit: false
                                };
                                return updated;
                            });
                            Toast.success({ message: 'Row updated successfully' });
                        }}
                        tooltip="Save"
                        tooltipOptions={{ position: 'top' }}
                    />
                ) : (
                    <Button
                        icon="pi pi-pencil"
                        className="e-sction-btn p-m-0 p-m-2"
                        onClick={() => {
                            setExcelData(prev => {
                                const updated = [...prev];
                                updated[rowIndex] = {
                                    ...updated[rowIndex],
                                    isEdit: true
                                };
                                return updated;
                            });
                        }}
                        tooltip="Edit"
                        tooltipOptions={{ position: 'top' }}
                    />
                )}
                <Button
                    icon="pi pi-trash"
                    className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => {
                        setIsDeleteHolidayConfirmation(true);
                        setDeletedIndex(rowIndex);
                    }}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="academicYearName">Academic Year Name</label>
                        <div className="custom-inputs">
                            <Dropdown
                                id="academicYearId"
                                value={formData?.academicYearId}
                                options={academicYearList}
                                onChange={(e) => handleInputChange("academicYearId", e.value)}
                                placeholder="Select Academic Year"
                                display="chip"
                                className='p-w-100'
                                filter
                                showClear
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {formData?.academicYearIdErr ? formData?.academicYearIdErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="academicYearName">Applicable Class</label>
                        <div className="custom-inputs">
                            <MultiSelect
                                id="className"
                                value={formData?.classesApplicable}
                                options={classList}
                                onChange={(e) => handleClassChange(e.value)}
                                placeholder="Select Classes"
                                display="chip"
                                className='p-w-100 e-multy-select'
                                filter
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {formData?.classesApplicableErr ? formData?.classesApplicableErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div>
                        <label htmlFor="importFile">Import Excel File</label>
                        <div className="p-d-flex p-flex-column p-jc-around p-mt-1">
                            {excelFileName && (
                                <div className="p-mb-2 p-d-flex p-ai-center">
                                    <i className="pi pi-file-excel" style={{ fontSize: '1.5rem', color: '#00A651', marginRight: '10px' }}></i>
                                    <span style={{ fontWeight: 'bold' }}>{excelFileName}</span>
                                </div>
                            )}
                            <div className='p-d-flex p-ai-center user-profile-btn'>
                                {!excelFileName && (
                                    <>
                                        <FileUpload
                                            ref={importFileUploadRef}
                                            name='importFile'
                                            customUpload
                                            auto
                                            mode="basic"
                                            uploadHandler={handleFileUpload}
                                            className="small-file-upload"
                                            accept=".xlsx,.xls,.csv"
                                        />
                                        <Button
                                            icon="pi pi-download"
                                            label="Sample"
                                            className="p-button-outlined p-button-secondary p-ml-2"
                                            onClick={downloadSampleCSV}
                                            tooltip="Download Sample CSV"
                                            tooltipOptions={{ position: 'top' }}
                                            style={{ height: '36px' }}
                                        />
                                    </>
                                )}
                                {excelFileName && (
                                    <div
                                        className="error-msg-alert p-ml-2"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            setIsDeleteExcelConfirmation(true);
                                        }}
                                    >
                                        <i className="pi pi-trash" style={{ fontSize: "16px", color: "red" }}></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <span className="error-msg" style={{ color: 'red' }}>
                    {formData?.holidayErr ? formData?.holidayErrText : null}
                </span>
                {excelData?.length > 0 && (
                    <div className="p-col-12 p-pt-3">
                        <div className="p-d-flex p-jc-between p-ai-center p-mb-2">
                            <h4>Holiday Data</h4>
                            <Button
                                icon="pi pi-plus"
                                label="Add Row"
                                className="btn-text-action-primary"
                                onClick={addNewExcelRow}
                            />
                        </div>
                        <div className='e-grade-master-table p-w-100'>
                            <DataTable
                                value={excelData}
                                responsiveLayout="scroll"
                                className="main-table table-td"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                                editMode="row"
                                rowClassName={(rowData) => {
                                    return overlapKeys.includes(getRowKey(rowData)) ? "overlap-row" : "";
                                }}
                            >
                                <Column header="Sr. No." body={excelSrNoBodyTemplate} style={{ width: '80px' }} />
                                <Column header="Start Date" body={excelStartDateBodyTemplate} />
                                <Column header="End Date" body={excelEndDateBodyTemplate} />
                                <Column header="Name" body={excelNameBodyTemplate} />
                                <Column header="Remark" body={excelRemarkBodyTemplate} />
                                <Column header="Actions" body={excelActionsBodyTemplate} style={{ width: '120px' }} />
                            </DataTable>
                        </div>
                    </div>
                )}

            </div>

            <div className='dialog-footer p-d-flex p-ai-center p-jc-end p-mt-3'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={() => onCancel()}>Cancel</Button>
                <Button className='p-m-0 btn-text-action-primary' label="Save" severity="secondary" raised onClick={() => AddUpdateTemplate()} />
            </div>

            {/* Image Delete Confirmation Dialog */}
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>

            <Dialog
                visible={isDeleteExcelConfirmation}
                onHide={handleCloseExcelConfirmation}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Excel File</span>
                    </div>
                }
                footer={renderExcelDeleteFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#FFA726', marginRight: '1rem' }}></i>
                    <span>Are you sure you want to delete this Excel file and all its data?</span>
                </div>
            </Dialog>
            <Dialog
                visible={isDeleteHolidayConfirmation}
                onHide={handleCloseHolidayConfirmation}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Holiday</span>
                    </div>
                }
                footer={renderHolidayDeleteFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', color: '#FFA726', marginRight: '1rem' }}></i>
                    <span>Are you sure you want to delete this holiday?</span>
                </div>
            </Dialog>
        </div>
    );
};

export default AddEditAcademicCalenderSpecific;